import {
	Box,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	TextField,
	Typography,
} from "@mui/material";
import React from "react";
import { sizes } from "../scenarioSetupNewUtils";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "../scenarioSetupNewSlice";

const commonHeight = sizes.h35;
const SW = sizes.w300;

export default function PredictionMethod() {
	const dispatch = useDispatch();
	const setupState = useSelector((store) => store.scenarioSetupNew);
	const {
		predictionMethodPeriodList,
		previousYearPeriodList,
		selectedLinearTrend,
		selectedRunRate,
		selectedConsensus,
		selectedPreviousYear,
		selectedDefaultInitialForecast,
		DefaultInitialForecast,
	} = setupState;

	const handleStateUpdate = (event, stateName) => {
		const value = event.target.value;
		dispatch(setState(stateName, value));
	};

	return (
		<Box>
			<Box sx={{ mt: 0, p: 2, border: 1, borderRadius: 1, borderColor: "#c6c6c6"}}>
				<Grid container columns={12} justifyContent="space-between" alignItems="center" spacing={2}>
					<Grid item sm={12} md={12} lg={12}>
						<Box sx={{ mt: 0 }}>
							<Typography sx={{ color: "black.main", fontWeight: "600", fontSize: "14px", }}>
								Prediction Method
							</Typography>
						</Box>
					</Grid>
					<Grid item sm={12} md={12} lg={12}>
						<Box>
							<Grid sm={12} md={12} lg={12} justifyContent="space-around" alignItems="center" columnGap={1} sx={{ display: "flex", }}>
								<Grid item sm={6} md={4} lg={4} xs={8}>
									<Box>
										<FormControl sx={{ width: "100%" }}>
											<InputLabel id="demo-simple-select-label">
												Linear Trend
											</InputLabel>
											<Select
												labelId="demo-simple-select-label"
												id="demo-simple-select"
												value={selectedLinearTrend}
												label="Linear Trend"
												sx={{
													height: commonHeight,
													width: SW,
													color: "black.main",
													mt: 1,
												}}
												onChange={(event) =>
													handleStateUpdate(event, "selectedLinearTrend")
												}
											>
												{predictionMethodPeriodList.map((item, index) => {
													return (
														<MenuItem key={index} value={item.name}>
															{item.name}
														</MenuItem>
													);
												})}
											</Select>
										</FormControl>
									</Box>
								</Grid>

								<Grid item sm={6} md={4} lg={4} xs={8}>
									<Box>
										<FormControl sx={{ width: "100%" }}>
											<InputLabel id="demo-simple-select-label">
												Run Rate
											</InputLabel>
											<Select
												labelId="demo-simple-select-label"
												id="demo-simple-select"
												value={selectedRunRate}
												label="Run Rate"
												sx={{
													height: commonHeight,
													width: SW,
													color: "black.main",
													mt: 1,
												}}
												onChange={(event) =>
													handleStateUpdate(event, "selectedRunRate")
												}
											>
												{predictionMethodPeriodList.map((item, index) => {
													return (
														<MenuItem key={index} value={item.name}>
															{item.name}
														</MenuItem>
													);
												})}
											</Select>
										</FormControl>
									</Box>
								</Grid>

								<Grid item sm={6} md={4} lg={4} xs={8}>
									<Box>
										<FormControl sx={{ width: "100%" }}>
											<InputLabel id="demo-simple-select-label">
												Previous Year
											</InputLabel>
											<Select
												labelId="demo-simple-select-label"
												id="demo-simple-select"
												value={selectedPreviousYear}
												label="Previous Year"
												sx={{
													height: commonHeight,
													width: SW,
													color: "black.main",
													mt: 1,
												}}
												onChange={(event) =>
													handleStateUpdate(event, "selectedPreviousYear")
												}
											>
												{previousYearPeriodList.map((item, index) => {
													return (
														<MenuItem key={index} value={item.name}>
															{item.name}
														</MenuItem>
													);
												})}
											</Select>
										</FormControl>
									</Box>
								</Grid>
							</Grid>
						</Box>
					</Grid>
				</Grid>
			</Box>
			<Box>
				<Grid sm={12} md={12} lg={12} justifyContent="space-around" alignItems="center" columnGap={1} sx={{ display: "flex", }}>
					<Grid item sm={6} md={6} mt={6} sx={{mt: 3}}>
						<Box>
							<FormControl sx={{ width: "100%" }}>
								<InputLabel id="demo-simple-select-label">
									Forecast
								</InputLabel>
								<Select
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									value={selectedConsensus}
									label="Forecast"
									sx={{
										height: "73px",
										width: SW,
										color: "black.main",
									}}
									onChange={(event) =>
										handleStateUpdate(event, "selectedConsensus")
									}
								>
									{predictionMethodPeriodList.map((item, index) => {
										return (
											<MenuItem key={index} value={item.name}>
												{item.name}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>
						</Box>
					</Grid>
					<Grid item sm={6} md={6} mt={6} sx={{mt: 3}}>
						<Box>
							<FormControl sx={{ width: "100%"}}>
								<InputLabel id="demo-simple-select-label">
									Default Initial Forecast
								</InputLabel>
								<Select
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									value={selectedDefaultInitialForecast}
									label="Default Initial Forecast"
									sx={{
										height: "73px",
										width: SW,
										color: "black.main",
									}}
									onChange={(event) =>
										handleStateUpdate(event, "selectedDefaultInitialForecast")
									}
								>
									{DefaultInitialForecast.map((item, index) => {
										return (
											<MenuItem key={index} value={item.name}>
												{item.name}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>
						</Box>
					</Grid>

				</Grid>
			</Box>
		</Box>
	);
}
